import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const LeadManagement = Loadable(lazy(() => import('./LeadManagement')));
const CustomerManagement = Loadable(lazy(() => import('./CustomerManagement')));

const crmRoutes = [
    {
        path: '/crm/leads',
        element: <LeadManagement />,
    },
    {
        path: '/crm/customers',
        element: <CustomerManagement />,
    },
];

export default crmRoutes;
